




















import { ProductsApi, SmsProductCharge } from '@/api';
import { Component, Prop, Vue } from 'vue-property-decorator';
import SentCurrentUsage from './sentCurrentUsage.vue';
import SmsBillingMonths from './tables/smsBillingMonths.vue';
import Toast from '../display/toast.vue';

@Component({
	components: {
		SentCurrentUsage,
		SmsBillingMonths,
	},
})
export default class SmsCurrentTabs extends Vue {
	@Prop({ type: Number, required: true })
	public productId!: number;
	@Prop({ type: Boolean, required: true })
	public notificationsLimitNear!: boolean;
	@Prop({ type: Number, required: true })
	public smsCount!: Number;
	@Prop({ type: Number, required: true })
	public maxSmsCount!: Number;

	public toast = new Toast();
	public notificationsGroups: SmsProductCharge[] = [];
	public currentNotificationLogs: SmsProductCharge[] = [];
	private api: ProductsApi = new ProductsApi();

	public async created() {
		this.getAlertsData();
	}

	public async getAlertsData() {
		if (!this.productId) return;

		try {
			const smsProductCharges = await this.api.getSmsProductCharges(this.productId);
			const currentDeliveryLogs = await this.api.getCurrentSmsDeliveryLogs(this.productId);

			this.currentNotificationLogs = currentDeliveryLogs.data?.data ?? [];
			this.notificationsGroups = smsProductCharges.data?.data ?? [];
		} catch (e) {
			this.toast.makeToast('Error', 'There was a problem getting alert data.', 'danger', false);
		}
	}
}
